// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#statistics{border-radius:20px;background-color:#20b2aa;box-shadow:0 4px 8px 0 rgba(0,0,0,.2);transition:.3s}#card-container{display:flex;flex-wrap:wrap}.card{cursor:pointer;margin:2%;width:20%;min-width:235px;padding:5px;border-radius:20px;background-color:#fff;box-shadow:0 4px 8px 0 rgba(0,0,0,.2);transition:.3s}.card:hover{box-shadow:0 8px 16px 0 rgba(0,0,0,.2)}h2{font-size:38px}", ""]);
// Exports
module.exports = exports;
